
const $ = window.$;

import '../afew.policies';
import '../sections/header';
import '../sections/lazy-video';
import '../sections/discount-flag';
import '../sections/sale-bar';
import { productImpressionsTracking } from '../afew.tagmanager';

if (window.eetImpressions) {
  productImpressionsTracking(window.eetImpressions);
}

function initMediastation() {
  const click = new Audio(window.click_url);
  $(document).on('click', 'a, button', () => {
    click.play();
  });
}

// wait for all inits and reorder sidebar
let findifyInitTimer = 0;
window.initFindifyFacets = function() {
  // reset timer
  if (findifyInitTimer) {
    clearTimeout(findifyInitTimer);
  }

  findifyInitTimer = setTimeout(() => {
    // move newsletter from fallback to findify
    window.headerApp.moveNewsletterToFindify();

    // hide sidebar on mobile
    window.headerApp.updateSidebarVisibility();

    // move best of to findify
    const $filterFindify = $('#nav-filter-findify');
    if ($filterFindify.length) {
      $('.filter-bestof')
      .attr('data-parent', '#nav-filter-findify')
      .siblings('.btn')
      .attr('data-target', '#nav-filter-findify .filter-bestof')
      .closest('.filter')
      .appendTo($filterFindify);
    }

    window.scrollToProduct();
    
  }, 0);
};

//scroll to last item
window.scrollToProduct = function() {
  if(location.hash.startsWith('#findify_')){
    var $el = $(location.hash);
    if($el.length){
      $el[0].scrollIntoView();
    }
  }
}

// toggle filters
window.updateFindifyFilters = function() {
  $('section.collection-products').removeClass('with-min-height');
  window.headerApp.updateSidebarVisibility();
  $('body,html').animate({
    scrollTop: 0,
  }, 200);
};

// toggle mobile menu
window.updateFindifySearch = function() {
  window.headerApp.show_menu = false;
};

// toggle mobile menu
window.updateFindifyRecommendations = function() {
  $('.shopify-section.findify-recommendation').each(/* @this HTMLElement */ function() {
    const $el = $(this);
    if ($el.find('.findify-recommendation').length) {
      $el.show();
    }
  });
};

// display fallback after 5s
const findifyFallbackTimer = setTimeout(() => {
  $('.findify-fallback').show();
  $('.findify-component-spinner').hide();
}, 5000);

// clear fallback timeout after findify has been loaded
window.findifyCallbacks = window.findifyCallbacks || [];
window.findifyCallbacks.push(() => {
  clearTimeout(findifyFallbackTimer);
});

window.getPreferredSizeType = function(sizeTypes) {
  if (!window.localStorage) {
    return false;
  }

  if (!Array.isArray(sizeTypes)) {
    return window.getPreferredSizeType([sizeTypes]);
  }

  const value = window.localStorage.getItem(`size_type_${sizeTypes.join('/')}`);
  return value ? value : false;
};

window.setPreferredSizeType = function(value, sizeTypes) {
  if (!window.localStorage) {
    return;
  }

  if (!Array.isArray(sizeTypes)) {
    window.setPreferredSizeType(value, [sizeTypes]);
    return;
  }

  if (!sizeTypes.includes(value)) {
    return;
  }

  window.localStorage.setItem(`size_type_${sizeTypes.join('/')}`, value);
};

window.getPreferredSneakerSizeType = function() {
  return window.getPreferredSizeType(['US', 'EU', 'UK', 'CM']);
};

window.setPreferredSneakerSizeType = function(value) {
  if (!value) {
    return;
  }
  window.setPreferredSizeType(value, ['US', 'EU', 'UK', 'CM']);
};

//scroll to findify product after page loading from cache (browser back button)
window.onpageshow = function(event) {
  if (event.persisted) {
    window.scrollToProduct();
  }
};

$(document).ready(() => {
  // load background images
  $('[data-background-image]').each(/* @this HTMLElement */ function() {
    const $el = $(this);
    $el.css('background-image', `url(${$el.data('background-image')})`);
  });

  // cookie settings link
  if (!$('body.template-policies').length) {
    $('footer a[href="/policies/privacy-policy"]').parent().after('<li><a href="#cookie-settings" class="optanon-show-settings">Cookie-Settings</a></li>');
  }

  // mobile search form
  $('#nav-main .toolbar input[type="search"]').closest('form').submit(() => {
    window.updateFindifySearch();
  });

  // newsletter trigger
  if (window.newsletter_form_id) {
    $(`a[href='${window.newsletter_signup_link}']`).on('click', () => {
      if(!window._klOnsite || !window._klOnsite.openForm) return true;

      window._klOnsite.openForm(window.newsletter_form_id);
      return false;
    });

    if (window.location.hash === '#newsletter') {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', window.newsletter_form_id]);
    }
  }

  // sale update
  if (window.sale_update_form_id) {
    $(`a[href='${window.sale_update_signup_link}']`).on('click', () => {
      if(!window._klOnsite || !window._klOnsite.openForm) return true;

      window._klOnsite.openForm(window.sale_update_form_id);
      return false;
    });
  }

  // stock update
  if (window.stock_update_form_id) {
    $(`a[href='${window.stock_update_signup_link}']`).on('click', () => {
      if(!window._klOnsite || !window._klOnsite.openForm) return true;

      window._klOnsite.openForm(window.stock_update_form_id);
      return false;
    });
  }

  if (window.mediastation) {
    initMediastation();
  }
});

const body = document.querySelector('body');

function hideCookieBanner() {
  const style = document.createElement('style');
  style.innerHTML = '#onetrust-consent-sdk{display: none;}';
  body.append(style);
}
if (Shopify && Shopify.designMode) {
  hideCookieBanner();
} else if (location.hostname.includes('store.net') || location.hostname.includes('127.0.0.1') || location.hostname.includes('.myshopify.com') || location.hostname.includes('afew-good-things.com')) {
  if (sessionStorage.hideCookieBanner) {
    if (location.search.indexOf('cb=1') !== -1) {
      sessionStorage.removeItem('hideCookieBanner');
    } else {
      hideCookieBanner();
    }
  } else if (location.search.indexOf('cb=0') !== -1) {
    sessionStorage.hideCookieBanner = true;
    hideCookieBanner();
  }
}
